document.addEventListener('DOMContentLoaded', function () {
    const dropZone      = document.getElementById('DropZone');
    const fileInput     = document.getElementById('ContactReference');
    const dropZoneText  = document.getElementById('DropZoneText');
    const previewContainer = document.getElementById('ImagePreviewContainer');
    const statusMsg     = document.getElementById('upload-status-message');
    const submitBtn     = document.getElementById('PurpleUploadSubmitBtn');
    const hiddenUrlField = document.getElementById('ContactFormFileUrl');

    if (!dropZone || !fileInput || !previewContainer) return;

    const maxImages = parseInt(dropZone.getAttribute('data-max-images')) || 5;
    const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

    let selectedFiles = [];
    let isUploading   = false; // Bloqueia dropzone e botão durante upload

    // ─── Validação de e-mail antes do upload ─────────────
    function checkRequiredFields() {
        const form = document.getElementById('PurpleContactForm');
        if (form) {
            const requiredInputs = form.querySelectorAll('[required]');
            for (const input of requiredInputs) {
                if (!input.value.trim()) {
                    setStatus('error', 'Por favor, preencha todos os campos obrigatórios (*) antes de anexar as imagens.');
                    input.focus();
                    return false;
                }
            }
        }
        return true;
    }

    // ─── Drag & Drop ─────────────────────────────────────────────────
    dropZone.addEventListener('click', () => {
        if (!isUploading && checkRequiredFields()) {
            fileInput.click();
        }
    });

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((evt) =>
        dropZone.addEventListener(evt, (e) => e.preventDefault(), false)
    );

    dropZone.addEventListener('drop', (e) => {
        if (!isUploading && checkRequiredFields()) {
            handleFiles(e.dataTransfer.files);
        }
    });

    fileInput.addEventListener('change', () => {
        if (!isUploading) {
            handleFiles(fileInput.files);
            fileInput.value = '';
        }
    });

    // ─── Gerencia seleção de arquivos ─────────────────────────────────
    function handleFiles(files) {
        const newFiles = Array.from(files).filter(f => f.type.startsWith('image/'));

        if (selectedFiles.length + newFiles.length > maxImages) {
            setStatus('error', `Máximo de ${maxImages} imagens permitido.`);
            return;
        }

        const oversized = newFiles.find(f => f.size > MAX_SIZE_BYTES);
        if (oversized) {
            setStatus('error', `"${oversized.name}" excede o limite de 10MB.`);
            return;
        }

        selectedFiles = [...selectedFiles, ...newFiles];
        updatePreviews();

        // Upload imediato ao adicionar arquivos
        triggerUpload();
    }

    function removeFile(index) {
        if (isUploading) return; // Não permite remover durante upload
        selectedFiles.splice(index, 1);
        hiddenUrlField.value = ''; // Invalida URLs anteriores
        updatePreviews();
        if (selectedFiles.length > 0) {
            triggerUpload();
        } else {
            setStatus('idle', '');
        }
    }

    function updatePreviews() {
        const dt = new DataTransfer();
        selectedFiles.forEach(f => dt.items.add(f));
        fileInput.files = dt.files;

        previewContainer.innerHTML = '';

        if (selectedFiles.length > 0) {
            dropZoneText.innerHTML = `<strong>${selectedFiles.length} de ${maxImages} imagens selecionadas</strong>`;
            dropZone.style.borderColor = 'var(--violet)';

            selectedFiles.forEach((file, index) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const item = document.createElement('div');
                    item.className = 'preview-item';

                    const img = document.createElement('img');
                    img.src = e.target.result;
                    img.className = 'preview-image';

                    const btn = document.createElement('button');
                    btn.className = 'preview-remove';
                    btn.innerHTML = '×';
                    btn.type = 'button';
                    btn.title = 'Remover imagem';
                    btn.onclick = (ev) => { ev.stopPropagation(); removeFile(index); };

                    item.appendChild(img);
                    item.appendChild(btn);
                    previewContainer.appendChild(item);
                };
                reader.readAsDataURL(file);
            });
        } else {
            dropZoneText.innerHTML = `Arraste as imagens aqui ou clique para enviar (Máximo ${maxImages})`;
            dropZone.style.borderColor = 'var(--line)';
        }
    }

    // ─── Upload dispara assim que arquivos são selecionados ───────────
    async function triggerUpload() {
        if (isUploading || selectedFiles.length === 0) return;

        isUploading = true;
        hiddenUrlField.value = ''; // Limpa campo oculto até receber novos links

        // Bloqueia UI durante upload
        setDropZoneLocked(true);
        if (submitBtn) submitBtn.disabled = true;
        setStatus('loading', `Enviando ${selectedFiles.length} imagem(ns)...`);

        const emailEl = document.getElementById('ContactEmail');
        const email = emailEl ? emailEl.value : '';

        try {
            const fd = new FormData();
            fd.append('email', email);
            selectedFiles.forEach(f => fd.append('files', f));

            // SEM Content-Type manual — navegador define os boundaries do multipart
            const response = await fetch('https://api.purpledeco.com.br/', {
                method: 'POST',
                body: fd
            });

            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err.error || 'Falha no upload.');
            }

            const data = await response.json();
            console.log('API response:', data);

            // A API retorna { urls: ["https://cdn.purpledeco.com.br/..."] }
            const urls = Array.isArray(data.urls) ? data.urls : [];
            console.log('URLs recebidas:', urls);

            // Injeta as URLs no campo oculto do formulário da Shopify
            hiddenUrlField.value = urls.join(' | ');

            setStatus('success', `✓ ${urls.length} imagem(ns) pronta(s).`);
        } catch (err) {
            setStatus('error', 'Erro no upload: ' + err.message);
            hiddenUrlField.value = '';
        } finally {
            isUploading = false;
            // Libera UI após upload
            setDropZoneLocked(false);
            if (submitBtn) submitBtn.disabled = false;
        }
    }

    // ─── Helpers ─────────────────────────────────────────────────────
    function setDropZoneLocked(locked) {
        dropZone.style.opacity = locked ? '0.5' : '1';
        dropZone.style.cursor  = locked ? 'not-allowed' : 'pointer';
        dropZone.style.pointerEvents = locked ? 'none' : 'auto';
        // O fileInput dentro do dropzone também fica bloqueado
        fileInput.disabled = locked;
    }

    function setStatus(type, msg) {
        if (!statusMsg) return;
        const colors = { loading: '#7C26C0', success: '#28a745', error: '#DC3545', idle: '#666' };
        statusMsg.style.color = colors[type] || '#666';
        statusMsg.textContent = msg;
    }
});